
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { map } from 'rxjs/operators';
import { HttpResponse } from '@angular/common/http';
import { BehaviorSubject, Observable} from 'rxjs';
import { PageControlProjects, ProjectsListResponse } from '@app-model/project-data';
import { ProjectIdData } from '@app-model/project-data';
@Injectable({
    providedIn: 'root'
})
export class ProjectService {
    constructor(private http: HttpClient) {}

    createProject(form) {
        let payload;
        switch (form.profile) {
            case "ADVERTISING":
                payload = this.advertisingProjectDTO(form);
                break;
            case "NON_ADVERTISING":
                payload = this.nonAdvertisingProjectDTO(form); 
                break;
            default:
                break;
        }
        return this.http.post(`${environment.api}/projects`, payload, {observe: 'response'}).pipe(map((response: HttpResponse<{id:string, errors?:{message:string}[]}>) => response));
    }
    patchProject(form) {

        return this.http.post(`${environment.api}/projects`, form, {observe: 'response'}).pipe(map((response: HttpResponse<{id:string, errors?:{message:string}[]}>) => response));
    }
    uploadProjectImage(file: File, id:string){
        const formData = new FormData();
        formData.append('file', file);
        return this.http.post(`${environment.api}/projects/${id}/upload-image`, formData).pipe(map((response) => response));
    }
    getProject(projectId: string): Observable<ProjectIdData> {

        return this.http.get<ProjectIdData>(`${environment.api}/projects/${projectId}`);
      
      }
    getProjects(filter: PageControlProjects) {
        const { profile, ...pageControl } = filter;
        let payload = {profile, pageControl}
        return this.http.post(`${environment.api}/projects/search`, payload).pipe(map((response: ProjectsListResponse) => response));
    }

    getProjectReport(projectId: string): Observable<any> {
        return this.http.get(`${environment.api}/projects/${projectId}/report`).pipe(
            map((response: any) => response)
        );
    }

    advertisingProjectDTO(form){
        return {
            name: form.name,
            description: form.description,
            profile: form.profile,
            client: form.client,
            agency: form.agency,
            director: form.director,
            producer: form.producer,
            type: form.type,
            nationality: form.nationality,
            mediaTypes: form.mediaTypes,
            inProgress: form.inProgress,
            start: this.convertDate(form.start),
            end: this.convertDate(form.end),  
        }

    }
    nonAdvertisingProjectDTO(form){
        return {
            name: form.name,
            description: form.description,
            profile: form.profile,
            internationalCoProduction: form.internationalCoProduction,
            resourcesAndInvestmentsEncouraged: form.resourcesAndInvestmentsEncouraged,
            partner: form.partner,
            temporalOrganization: form.temporalOrganization,
            type: form.type,
            classification: form.classification,
            customMade: form.customMade,
            contractor: form.contractor,
            inProgress: form.inProgress,
            start: this.convertDate(form.start),
            end: this.convertDate(form.end),
        }

    }
    private convertDate(date: string) {

        if (!date) {

            return null;
        }
		return new Date(date).toISOString().slice(0, 10);
	}


    
}
